import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Drawer, Form, Input, notification, TimePicker, Icon, Modal, Radio, Button, Collapse } from "antd";
import axios from "axios";
import moment from "moment";
import { GlobalContext } from "../../../GlobalState";

const { Panel } = Collapse;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class FormVideoConf extends Component {
    static contextType = GlobalContext;
    state = {
        btnIniciar: false,
        assunto: "",
        dia: null,
        hora: null,
        inicio: null,
        fim: null,
        duracao: moment("01:00", "HH:mm"),
        gravarSessao: false,
        habilitarChat: false,
        totalContratado: "",
        recorrente: false,
        recorrenciaIntervalo: 1,
        recorrencia: "SEMANA",
        recorrenciaFim: null,
        ficheiroExportar: "",
        ficheiroNomeExportar: "",
        btnDescarregar: false,
        //EXTERNA
        meetExterna: false,
        meetExternaConvite: "",
        //LOADING
        iconLoading: false,
        //NOTIFICAR
        notificar: false,
        //PERMISSOES
        permissaoDescarregar: 1,
        soGestoresVerDescarregar: false,
        //PARTICIANTES
        todos: false,
        participantes: [],
        //DRAWER PESQUISAR PARTICIPATES,
        visibleDrawerPesqusiar: false,
        //MODAL PARTICIPANTES DUPLICADOS
        iniciar: false,
        visibleParticipantes: false,
        loadingLista: false,
        participantesDuplicados: [],
        periodos: 0,
        cursoSumario: false,
        sumarios: [{ key: 1, conteudo: { manha: "", tarde: "" } }],
        metodologias: [{ key: 1, conteudo: { manha: "", tarde: "" } }],
        equipamentos: [{ key: 1, conteudo: { manha: "", tarde: "" } }],
        sumariosHora: [
            {
                key: 1,
                conteudo: {
                    manha: "",
                    tarde: "",
                    manhaInicio: null,
                    manhaFim: null,
                    tardeInicio: null,
                    tardeFim: null
                }
            }
        ],
        observacoes: "",
        originalData: {
            periodos: "",
            sumarios: [],
            metodologias: [],
            equipamentos: [],
            sumariosHora: [],
            observacoes: ""
        },
        guardarDisabled: true
    };

    handleChange = e => {
        this.setState({
            periodos: e.target.value,
            guardarDisabled: true
        });
    };

    addPanelSumarios = () => {
        const { sumarios } = this.state;
        const newKey = sumarios.length + 1;
        this.setState({
            sumarios: [...sumarios, { key: newKey, conteudo: { manha: "", tarde: "" } }],
            guardarDisabled: true
        });

        const jsonString = JSON.stringify(sumarios);

        var item = new FormData();

        item.append("data", jsonString);
    };

    addPanelMetodologias = () => {
        const { metodologias } = this.state;
        const newKey = metodologias.length + 1;
        this.setState({
            metodologias: [...metodologias, { key: newKey, conteudo: { manha: "", tarde: "" } }],
            guardarDisabled: true
        });

        const jsonString = JSON.stringify(metodologias);

        var item = new FormData();

        item.append("data", jsonString);
    };

    addPanelEquipamentos = () => {
        const { equipamentos } = this.state;
        const newKey = equipamentos.length + 1;
        this.setState({
            equipamentos: [...equipamentos, { key: newKey, conteudo: { manha: "", tarde: "" } }],
            guardarDisabled: true
        });

        const jsonString = JSON.stringify(equipamentos);

        var item = new FormData();

        item.append("data", jsonString);
    };

    addPanelSumariosHora = () => {
        const { sumariosHora } = this.state;
        const newKey = sumariosHora.length + 1;
        this.setState({
            sumariosHora: [
                ...sumariosHora,
                {
                    key: newKey,
                    conteudo: {
                        manha: "",
                        tarde: "",
                        manhaInicio: null,
                        manhaFim: null,
                        tardeInicio: null,
                        tardeFim: null
                    }
                }
            ],
            guardarDisabled: true
        });

        const jsonString = JSON.stringify(sumariosHora);

        var item = new FormData();

        item.append("data", jsonString);
    };

    handleInputChangeSumarios = (e, panelKey, field) => {
        const { sumarios } = this.state;
        const updatedPanels = sumarios.map(panel => {
            if (panel.key === panelKey) {
                const updatedContent = { ...panel.conteudo, [field]: e.target.value };
                return {
                    ...panel,
                    conteudo: updatedContent
                };
            }
            return panel;
        });
        this.setState({
            sumarios: updatedPanels,
            guardarDisabled: true
        });
    };

    handleInputChangeMetodologias = (e, panelKey, field) => {
        const { metodologias } = this.state;
        const updatedPanels = metodologias.map(panel => {
            if (panel.key === panelKey) {
                const updatedContent = { ...panel.conteudo, [field]: e.target.value };
                return {
                    ...panel,
                    conteudo: updatedContent
                };
            }
            return panel;
        });
        this.setState({
            metodologias: updatedPanels,
            guardarDisabled: true
        });
    };

    handleInputChangeEquipamentos = (e, panelKey, field) => {
        const { equipamentos } = this.state;
        const updatedPanels = equipamentos.map(panel => {
            if (panel.key === panelKey) {
                const updatedContent = { ...panel.conteudo, [field]: e.target.value };
                return {
                    ...panel,
                    conteudo: updatedContent
                };
            }
            return panel;
        });
        this.setState({
            equipamentos: updatedPanels,
            guardarDisabled: true
        });
    };

    handleInputChangeSumariosHora = (e, panelKey, field) => {
        const { sumariosHora } = this.state;
        const updatedPanels = sumariosHora.map(panel => {
            if (panel.key === panelKey) {
                const updatedContent = { ...panel.conteudo, [field]: e.target.value };
                return {
                    ...panel,
                    conteudo: updatedContent
                };
            }
            return panel;
        });
        this.setState({
            sumariosHora: updatedPanels,
            guardarDisabled: true
        });
    };

    handleTimeChangeSumariosHora = (time, timeString, panelKey, field) => {
        const { sumariosHora } = this.state;
        const updatedPanels = sumariosHora.map(panel => {
            if (panel.key === panelKey) {
                return {
                    ...panel,
                    conteudo: { ...panel.conteudo, [field]: timeString }
                };
            }
            return panel;
        });
        this.setState({
            sumariosHora: updatedPanels,
            guardarDisabled: true
        });
    };

    guardar = () => {
        var item = new FormData();

        const JSONStringEquipamentos = JSON.stringify(this.state.equipamentos);
        const JSONStringMetodologias = JSON.stringify(this.state.metodologias);
        const JSONStringSumariosHora = JSON.stringify(this.state.sumariosHora);
        const JSONStringSumario = JSON.stringify(this.state.sumarios);

        item.append("videoConfId", this.props.videoConfId);
        item.append("cursoId", localStorage.getItem("codigo_curso"));
        item.append("equipamentos", JSONStringEquipamentos);
        item.append("metodologias", JSONStringMetodologias);
        item.append("sumarios", JSONStringSumario);
        item.append("sumariosHora", JSONStringSumariosHora);
        item.append("periodos", this.state.periodos);
        item.append("observacoes", this.state.observacoes);

        axios({
            method: "post",
            url: "/api/gerir-videoconferencia/guardar-equipamento",
            data: item
        })
            .then(response => {
                openNotificationWithIcon("success", "Sucesso", "Stepmeet alterada");
                this.setState({
                    guardarDisabled: false,
                    iconLoading: false
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data);
                this.setState({
                    iconLoading: false
                });
            });
    };

    exportar = () => {
        const cursoId = localStorage.getItem("codigo_curso");
        const videoId = this.props.videoConfId;

        this.setState(
            {
                visibleExportar: true,
                btnDescarregar: true
            },
            () => {
                axios({
                    method: "get",
                    url: this.state.cursoSumario ? "/api/pdf/sumario" : "api/pdf/sumario-com-horas",
                    params: {
                        cursoId: cursoId,
                        videoId: videoId
                    }
                })
                    .then(response => {
                        this.setState({
                            btnDescarregar: false,
                            ficheiroExportar: response.data.ficheiro,
                            ficheiroNomeExportar: response.data.nome
                        });
                    })
                    .catch(error => {
                        if (error.response.data === "SEM_REGISTOS")
                            openNotificationWithIcon("warning", "Atenção", "Não existem registo para serem exportados!");
                        else openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");

                        this.setState({
                            visibleExportar: false
                        });
                    });
            }
        );
    };

    carregarDetalhe = () => {
        axios({
            method: "get",
            url: "/api/gerir-videoconferencia/carregar-sumario",
            params: {
                id: this.props.videoConfId
            }
        })
            .then(response => {
                const dadosOriginais = {
                    periodos: response.data.periodos ? response.data.periodos : this.state.periodos,
                    equipamentos: response.data.equipamentos?.length > 0 ? response.data.equipamentos : this.state.equipamentos,
                    metodologias: response.data.metodologias?.length > 0 ? response.data.metodologias : this.state.metodologias,
                    sumarios: response.data.sumarios?.length > 0 ? response.data.sumarios : this.state.sumarios,
                    sumariosHora: response.data.sumariosHora?.length > 0 ? response.data.sumariosHora : this.state.sumariosHora,
                    observacoes: response.data.observacoes ? response.data.observacoes : this.state.observacoes
                };

                this.setState({
                    ...dadosOriginais,
                    originalData: JSON.stringify(dadosOriginais),
                    cursoSumario: response.data.sumarioGeral,
                    guardarDisabled: response.data.equipamentos.length === 0
                });
            })
            .catch(() => {});
    };

    afterVisibleChange = aberto => {
        if (aberto) {
            this.props.form.resetFields();
            this.carregarDetalhe();
        } else {
            this.setState({
                periodos: 0,
                sumarios: [{ key: 1, conteudo: { manha: "", tarde: "" } }],
                metodologias: [{ key: 1, conteudo: { manha: "", tarde: "" } }],
                equipamentos: [{ key: 1, conteudo: { manha: "", tarde: "" } }],
                sumariosHora: [
                    {
                        key: 1,
                        conteudo: {
                            manha: "",
                            tarde: "",
                            manhaInicio: null,
                            manhaFim: null,
                            tardeInicio: null,
                            tardeFim: null
                        }
                    }
                ],
                observacoes: ""
            });
        }
    };

    sumarioHeader = titulo => {
        return (
            <div className="header-panel">
                <span className="title">{titulo}</span>
                <br />
                <div className="subtitle">
                    <span className="subtitle-text">
                        (descrição clara de Matérias lecionadas: Descrição detalhada e sequencial dos conteúdos programáticos abordados na
                        sessão, alinhados com o referencial do Catálogo Nacional de Qualificações (CNQ))
                    </span>
                </div>
            </div>
        );
    };

    metodologiaHeader = () => {
        return (
            <div className="header-panel">
                <span className="title">Metodologias / Estratégias</span>
                <br />
                <div className="subtitle">
                    <span className="subtitle-text">
                        (descrição clara dos métodos aplicados: exposivo, demonstravo, avo/parcipavo) ou trabalhos prácos realizados)
                    </span>
                </div>
            </div>
        );
    };

    assuntosHeader = () => {
        return (
            <div className="header-panel">
                <span className="title">Assuntos</span>
                <br />
                <div className="subtitle">
                    <span className="subtitle-text">
                        (descrição clara dos suportes ulizados: apresentações, manuais, equipamentos, ferramentas digitais ou outros)
                    </span>
                </div>
            </div>
        );
    };

    render() {
        const { TextArea } = Input;
        const {
            //LOADING
            iconLoading,
            sumarios,
            sumariosHora,
            metodologias,
            equipamentos,
            cursoSumario,
            periodos,
            observacoes,
            btnDescarregar,
            ficheiroExportar,
            ficheiroNomeExportar,
            visibleExportar,
            guardarDisabled
        } = this.state;

        return (
            <>
                <Drawer
                    className="drawer-add-cursos drawer-videoconferencias drawer-stepmeets"
                    title="Informações do Sumário"
                    width={720}
                    onClose={this.props.onClose}
                    visible={this.props.visible}
                    style={{
                        overflow: "auto",
                        height: "calc(100% - 108px)",
                        paddingBottom: "108px"
                    }}
                    maskClosable={false}
                    afterVisibleChange={this.afterVisibleChange}
                >
                    <div className="bloco-info">
                        <Form className="form-add-curso" layout="horizontal">
                            <Form.Item label="Períodos">
                                <Radio.Group value={periodos} onChange={this.handleChange}>
                                    <Radio value={0}>Dia Completo</Radio>
                                    <Radio value={1}>Manhã</Radio>
                                    <Radio value={2}>Tarde</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Collapse defaultActiveKey={["1", "2"]} className="collapse-campos">
                                {cursoSumario ? (
                                    <Panel header="Sumario" key="1">
                                        <span style={{ fontSize: 12 }}>
                                            Descrição clara de Matérias lecionadas: Descrição detalhada e sequencial dos conteúdos
                                            programáticos abordados na sessão, alinhados com o referencial do Catálogo Nacional de
                                            Qualificações (CNQ)
                                        </span>

                                        <Form.Item>
                                            {sumarios.map(panel => (
                                                <div key={panel.key} style={{ marginBottom: 16 }}>
                                                    {(periodos == 0 || periodos == 1) && (
                                                        <Form.Item
                                                            label={`Sumário`}
                                                            name={`assuntoManha_${panel.key}`}
                                                            rules={[{ required: true, message: "Campo obrigatório" }]}
                                                        >
                                                            <TextArea
                                                                rows={4}
                                                                style={{ height: "100%" }}
                                                                value={panel.conteudo.manha}
                                                                onChange={e => this.handleInputChangeSumarios(e, panel.key, "manha")}
                                                            />
                                                        </Form.Item>
                                                    )}

                                                    {(periodos == 0 || periodos == 2) && (
                                                        <Form.Item
                                                            label={`Sumário`}
                                                            name={`assuntoTarde_${panel.key}`}
                                                            rules={[{ required: true, message: "Campo obrigatório" }]}
                                                        >
                                                            <TextArea
                                                                rows={4}
                                                                style={{ height: "100%" }}
                                                                value={panel.conteudo.tarde}
                                                                onChange={e => this.handleInputChangeSumarios(e, panel.key, "tarde")}
                                                            />
                                                        </Form.Item>
                                                    )}
                                                </div>
                                            ))}
                                            <Button type="dashed" onClick={this.addPanelSumarios} style={{ marginTop: 16 }}>
                                                + Adicionar Painel
                                            </Button>
                                        </Form.Item>
                                    </Panel>
                                ) : (
                                    <Panel header="Sumario Horas" key="1">
                                        <span style={{ fontSize: 12 }}>
                                            Descrição clara de Matérias lecionadas: Descrição detalhada e sequencial dos conteúdos
                                            programáticos abordados na sessão, alinhados com o referencial do Catálogo Nacional de
                                            Qualificações (CNQ)
                                        </span>
                                        {sumariosHora.map(panel => (
                                            <div key={panel.key} style={{ marginBottom: 16 }}>
                                                {(periodos == 0 || periodos == 1) && (
                                                    <>
                                                        <div style={{ display: "flex" }}>
                                                            <Form.Item label={`Hora Início`}>
                                                                <TimePicker
                                                                    className="input-50"
                                                                    name="Hora Início"
                                                                    style={{ width: "50% !important" }}
                                                                    defaultOpenValue={moment("00:00", "HH:mm")}
                                                                    suffixIcon={false}
                                                                    clearIcon={false}
                                                                    minuteStep={15}
                                                                    placeholder="Início"
                                                                    value={
                                                                        panel.conteudo.manhaInicio
                                                                            ? moment(panel.conteudo.manhaInicio, "HH:mm:ss")
                                                                            : null
                                                                    }
                                                                    onChange={time =>
                                                                        this.handleTimeChangeSumariosHora(
                                                                            time,
                                                                            time ? time.format("HH:mm:ss") : null,
                                                                            panel.key,
                                                                            "manhaInicio"
                                                                        )
                                                                    }
                                                                    format="HH:mm"
                                                                />
                                                            </Form.Item>
                                                            <Form.Item label={`Hora Fim`}>
                                                                <TimePicker
                                                                    className="input-50"
                                                                    name="Hora Fim"
                                                                    style={{ width: "50% !important" }}
                                                                    defaultOpenValue={moment("00:00", "HH:mm")}
                                                                    suffixIcon={false}
                                                                    clearIcon={false}
                                                                    minuteStep={15}
                                                                    placeholder="Fim"
                                                                    value={
                                                                        panel.conteudo.manhaFim
                                                                            ? moment(panel.conteudo.manhaFim, "HH:mm:ss")
                                                                            : null
                                                                    }
                                                                    onChange={time =>
                                                                        this.handleTimeChangeSumariosHora(
                                                                            time,
                                                                            time ? time.format("HH:mm:ss") : null,
                                                                            panel.key,
                                                                            "manhaFim"
                                                                        )
                                                                    }
                                                                    format="HH:mm"
                                                                />
                                                            </Form.Item>
                                                        </div>

                                                        <Form.Item
                                                            label={`Sumário`}
                                                            name={`assuntoManha_${panel.key}`}
                                                            rules={[{ required: true, message: "Campo obrigatório" }]}
                                                        >
                                                            <TextArea
                                                                rows={4}
                                                                style={{ height: "100%" }}
                                                                value={panel.conteudo.manha}
                                                                onChange={e => this.handleInputChangeSumariosHora(e, panel.key, "manha")}
                                                            />
                                                        </Form.Item>
                                                    </>
                                                )}

                                                {(periodos == 0 || periodos == 2) && (
                                                    <>
                                                        <div style={{ display: "flex" }}>
                                                            <Form.Item label={`Hora Início`}>
                                                                <TimePicker
                                                                    className="input-50"
                                                                    name="Hora Início"
                                                                    defaultOpenValue={moment("00:00", "HH:mm")}
                                                                    suffixIcon={false}
                                                                    clearIcon={false}
                                                                    minuteStep={15}
                                                                    placeholder="Início"
                                                                    value={
                                                                        panel.conteudo.tardeInicio
                                                                            ? moment(panel.conteudo.tardeInicio, "HH:mm:ss")
                                                                            : null
                                                                    }
                                                                    onChange={time =>
                                                                        this.handleTimeChangeSumariosHora(
                                                                            time,
                                                                            time ? time.format("HH:mm:ss") : null,
                                                                            panel.key,
                                                                            "tardeInicio"
                                                                        )
                                                                    }
                                                                    format="HH:mm"
                                                                />
                                                            </Form.Item>
                                                            <Form.Item label={`Hora Fim`}>
                                                                <TimePicker
                                                                    className="input-50"
                                                                    name="Hora Fim"
                                                                    defaultOpenValue={moment("00:00", "HH:mm")}
                                                                    suffixIcon={false}
                                                                    clearIcon={false}
                                                                    minuteStep={15}
                                                                    placeholder="Fim"
                                                                    value={
                                                                        panel.conteudo.tardeFim
                                                                            ? moment(panel.conteudo.tardeFim, "HH:mm:ss")
                                                                            : null
                                                                    }
                                                                    onChange={time =>
                                                                        this.handleTimeChangeSumariosHora(
                                                                            time,
                                                                            time ? time.format("HH:mm:ss") : null,
                                                                            panel.key,
                                                                            "tardeFim"
                                                                        )
                                                                    }
                                                                    format="HH:mm"
                                                                />
                                                            </Form.Item>
                                                        </div>

                                                        <Form.Item
                                                            label={`Sumário`}
                                                            name={`assuntoTarde_${panel.key}`}
                                                            rules={[{ required: true, message: "Campo obrigatório" }]}
                                                        >
                                                            <TextArea
                                                                rows={4}
                                                                style={{ height: "100%" }}
                                                                value={panel.conteudo.tarde}
                                                                onChange={e => this.handleInputChangeSumariosHora(e, panel.key, "tarde")}
                                                            />
                                                        </Form.Item>
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                        <Button type="dashed" onClick={this.addPanelSumariosHora} style={{ marginTop: 16 }}>
                                            + Adicionar Painel
                                        </Button>
                                    </Panel>
                                )}

                                <Panel header="Metodologias / Estratégias" key="2">
                                    <Form.Item>
                                        <span style={{ fontSize: 12 }}>
                                            Descrição clara dos métodos aplicados: expositivo, demonstrativo, ativo/participativo) ou
                                            trabalhos práticos realizados
                                        </span>
                                        {metodologias.map(panel => (
                                            <div key={panel.key} style={{ marginBottom: 16 }}>
                                                {(periodos == 0 || periodos == 1) && (
                                                    <Form.Item
                                                        name={`assuntoManha_${panel.key}`}
                                                        rules={[{ required: true, message: "Campo obrigatório" }]}
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            className="text-area"
                                                            style={{ height: "100%" }}
                                                            value={panel.conteudo.manha}
                                                            onChange={e => this.handleInputChangeMetodologias(e, panel.key, "manha")}
                                                        />
                                                    </Form.Item>
                                                )}

                                                {(periodos == 0 || periodos == 2) && (
                                                    <Form.Item
                                                        name={`assuntoTarde_${panel.key}`}
                                                        rules={[{ required: true, message: "Campo obrigatório" }]}
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            style={{ height: "100%" }}
                                                            value={panel.conteudo.tarde}
                                                            onChange={e => this.handleInputChangeMetodologias(e, panel.key, "tarde")}
                                                        />
                                                    </Form.Item>
                                                )}
                                            </div>
                                        ))}
                                        <Button type="dashed" onClick={this.addPanelMetodologias} style={{ marginTop: 16 }}>
                                            + Adicionar Painel
                                        </Button>
                                    </Form.Item>
                                </Panel>

                                <Panel header={"Recursos, materiais didáticos e equipamentos utilizados na sessão"} key="3">
                                    <Form.Item>
                                        <span style={{ fontSize: 12 }}>
                                            Descrição clara dos suportes utilizados: apresentações, manuais, equipamentos, ferramentas
                                            digitais ou outros
                                        </span>

                                        {equipamentos.map(panel => (
                                            <div key={panel.key} style={{ marginBottom: 16 }}>
                                                {(periodos == 0 || periodos == 1) && (
                                                    <Form.Item
                                                        name={`assuntoManha_${panel.key}`}
                                                        rules={[{ required: true, message: "Campo obrigatório" }]}
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            className="text-area"
                                                            style={{ height: "100%" }}
                                                            value={panel.conteudo.manha}
                                                            onChange={e => this.handleInputChangeEquipamentos(e, panel.key, "manha")}
                                                        />
                                                    </Form.Item>
                                                )}

                                                {(periodos == 0 || periodos == 2) && (
                                                    <Form.Item
                                                        name={`assuntoTarde_${panel.key}`}
                                                        rules={[{ required: true, message: "Campo obrigatório" }]}
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            style={{ height: "100%" }}
                                                            value={panel.conteudo.tarde}
                                                            onChange={e => this.handleInputChangeEquipamentos(e, panel.key, "tarde")}
                                                        />
                                                    </Form.Item>
                                                )}
                                            </div>
                                        ))}
                                        <Button type="dashed" onClick={this.addPanelEquipamentos} style={{ marginTop: 16 }}>
                                            + Adicionar Painel
                                        </Button>
                                    </Form.Item>
                                </Panel>

                                <Panel header={"Observações"} key="4">
                                    <Form.Item>
                                        <TextArea
                                            rows={4}
                                            style={{ height: "100%" }}
                                            value={observacoes}
                                            onChange={event =>
                                                this.setState({
                                                    observacoes: event.target.value,
                                                    guardarDisabled: true
                                                })
                                            }
                                        />
                                    </Form.Item>
                                </Panel>
                            </Collapse>
                        </Form>
                    </div>

                    <div className="ant-drawer-footer">
                        <Link
                            to="#"
                            className="botao-secundario"
                            onClick={this.props.onClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Voltar
                        </Link>
                        <button
                            className="botao-principal"
                            style={{ marginRight: 20, display: "inline-block" }}
                            disabled={iconLoading}
                            onClick={() => this.guardar()}
                        >
                            {iconLoading ? <Icon type="loading" /> : null}
                            Guardar
                        </button>
                        <button className="botao-principal" disabled={guardarDisabled} onClick={() => this.exportar()}>
                            {iconLoading ? <Icon type="loading" /> : null}
                            Gerar Documento
                        </button>
                    </div>
                </Drawer>
                <Modal
                    visible={visibleExportar}
                    okText={
                        <a
                            href={ficheiroExportar}
                            download={ficheiroNomeExportar}
                            onClick={() => this.setState({ visibleExportar: false })}
                        >
                            Descarregar
                        </a>
                    }
                    onCancel={() => this.setState({ visibleExportar: false })}
                    cancelText="Cancelar"
                    okButtonProps={{ disabled: btnDescarregar }}
                    maskClosable={false}
                    className="exportar-csv"
                >
                    <div className="exportar-csv-bloco">
                        {btnDescarregar ? (
                            <>
                                <p>
                                    <Icon type="loading" />
                                </p>
                                <p className="texto">A gerar documento...</p>
                            </>
                        ) : (
                            <>
                                <p>
                                    <Icon type="check-circle" style={{ color: "#84bd00" }} />
                                </p>
                                <p className="texto">Dados exportados com sucesso!</p>
                                <p className="ficheiro-extensao">.{ficheiroExportar.split(".")[ficheiroExportar.split(".").length - 1]}</p>
                            </>
                        )}
                    </div>
                </Modal>
            </>
        );
    }
}
const FormFormVideoConf = Form.create({ name: "form-video-conf" })(FormVideoConf);

export default FormFormVideoConf;
